import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { OrdersActions } from '../store/actions';

const useUserOrders = (isAuthenticated: boolean, isHardUser: boolean) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(OrdersActions.getOrders.reset());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated && isHardUser) dispatch(OrdersActions.getOrders.request({ params: { page_size: 1000 } }));
  }, [dispatch, isAuthenticated, isHardUser]);
};

export default useUserOrders;
